import { styledComponent, Box, ImageBackground } from '@hermes/web-components'

export const BookDetailsMarkup = styledComponent(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: 0,
  [theme.breakpoints.up('md')]: {
    display: 'grid',
    marginTop: '16px',
    gridTemplateColumns: 'minmax(0%, 553px) minmax(0%, 653px)'
  }
}))

export const BookImageContainer = styledComponent(ImageBackground)(({ theme }) => ({
  height: '675px',
  padding: '64px 100px 76px',
  borderRadius: '16px',
  position: 'relative',
  span: {
    height: '100% !important'
  },
  img: {
    height: '535px'
  },

  [theme.breakpoints.down('md')]: {
    height: '436px',
    padding: '20px 40px 36px',
    width: 'calc(100% + 32px)',
    margin: '0 -16px',
    borderRadius: 0,
    overflow: 'hidden',
    img: {
      height: '380px'
    },

    '&:after': {
      zIndex: 900,
      content: '""',
      padding: '8px',
      borderRadius: '16px 16px 0 0',
      backgroundColor: theme.palette.neutral.light,
      width: '100%',
      left: 0,
      position: 'absolute',
      bottom: 0
    }
  }
}))
